module.exports = __webpack_public_path__ + "static/media/AU 2019 Research Roster - Feedback Workshops - Oct 14.219e4f78.csv";